import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';

export const EmailTemplateTableHeaders = ({
  t,
  onSort,
}: SortableTableHeadersProps) => {
  return (
    <>
      <TableHead
        text={t('common:name')}
        thClassName="max-sm:min-w-[170px]"
        sortable
        onSortClick={() => onSort?.('emailTemplateName')}
      />
      <TableHead text={t('common:type')} thClassName="max-sm:min-w-[170px]" />
      <TableHead
        text={t('common:status')}
        thClassName="text-center min-w-0 w-0"
      />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
